function drawStars(ctx, w, h, count) {
    for (let i = 0; i < count; i++) {
        const x = Math.random() * w;
        const y = Math.random() * h;
        const r = Math.random() * 1.6 + 0.3;
        ctx.globalAlpha = 0.25 + Math.random() * 0.75;
        ctx.fillStyle = Math.random() > 0.75 ? "#F3D085" : "#FBF7EE";
        ctx.beginPath();
        ctx.arc(x, y, r, 0, Math.PI * 2);
        ctx.fill();
    }
    ctx.globalAlpha = 1;
}

function drawSparkle(ctx, x, y, s, color) {
    ctx.save();
    ctx.translate(x, y);
    ctx.fillStyle = color;
    ctx.beginPath();
    for (let i = 0; i < 4; i++) {
        ctx.rotate(Math.PI / 2);
        ctx.lineTo(0, -s);
        ctx.lineTo(s * 0.18, -s * 0.18);
    }
    ctx.fill();
    ctx.restore();
}

function drawPhoto(ctx, img, cx, cy, r) {
    const iw = img.naturalWidth;
    const ih = img.naturalHeight;
    const s = Math.min(iw, ih);
    const sx = (iw - s) / 2;
    const sy = Math.max(0, ih * 0.08);
    ctx.save();
    ctx.beginPath();
    ctx.arc(cx, cy, r, 0, Math.PI * 2);
    ctx.clip();
    ctx.drawImage(img, sx, sy, s, s, cx - r, cy - r, r * 2, r * 2);
    ctx.restore();
    ctx.beginPath();
    ctx.arc(cx, cy, r + 8, 0, Math.PI * 2);
    ctx.strokeStyle = "#C59B27";
    ctx.lineWidth = 4;
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(cx, cy, r + 16, 0, Math.PI * 2);
    ctx.strokeStyle = "rgba(243,208,133,0.45)";
    ctx.lineWidth = 1.5;
    ctx.stroke();
    drawSparkle(ctx, cx - r - 26, cy - r * 0.5, 18, "#FFD700");
    drawSparkle(ctx, cx + r + 26, cy + r * 0.35, 14, "#FFD700");
}

export function renderPoster(canvas, photo = null) {
    const W = 1080;
    const H = 1350;
    canvas.width = W;
    canvas.height = H;
    const ctx = canvas.getContext("2d");

    const bg = ctx.createLinearGradient(0, 0, 0, H);
    bg.addColorStop(0, "#0B0716");
    bg.addColorStop(0.55, "#17102b");
    bg.addColorStop(1, "#0B0716");
    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, W, H);

    const glow = ctx.createRadialGradient(W / 2, H * 0.4, 60, W / 2, H * 0.4, 620);
    glow.addColorStop(0, "rgba(107,56,130,0.5)");
    glow.addColorStop(1, "rgba(107,56,130,0)");
    ctx.fillStyle = glow;
    ctx.fillRect(0, 0, W, H);

    drawStars(ctx, W, H, 150);

    ctx.strokeStyle = "#C59B27";
    ctx.lineWidth = 3;
    ctx.strokeRect(46, 46, W - 92, H - 92);
    ctx.strokeStyle = "rgba(243,208,133,0.55)";
    ctx.lineWidth = 1;
    ctx.strokeRect(62, 62, W - 124, H - 124);
    [[46, 46], [W - 46, 46], [46, H - 46], [W - 46, H - 46]].forEach(([x, y]) => drawSparkle(ctx, x, y, 26, "#F3D085"));

    ctx.textAlign = "center";
    ctx.fillStyle = "rgba(243,208,133,0.85)";
    ctx.font = "500 28px 'JetBrains Mono', monospace";
    ctx.fillText("T H E   M A R Y   M A N Z U R   E X P E R I E N C E", W / 2, 132);

    if (photo) drawPhoto(ctx, photo, W / 2, 348, 152);
    else drawSparkle(ctx, W / 2, 340, 60, "#F3D085");

    ctx.fillStyle = "#F3D085";
    ctx.font = "italic 600 118px 'Cormorant Garamond', Georgia, serif";
    ctx.fillText("Mary", W / 2, 620);
    ctx.fillText("Manzur", W / 2, 745);

    ctx.fillStyle = "rgba(251,247,238,0.9)";
    ctx.font = "300 32px 'Cormorant Garamond', Georgia, serif";
    ctx.fillText("Birthday Edition — 2026", W / 2, 798);

    // cake
    const cx = W / 2;
    const cy = 1068;
    ctx.fillStyle = "#2A1438";
    ctx.strokeStyle = "#F3D085";
    ctx.lineWidth = 3;
    const tiers = [{ w: 260, h: 68 }, { w: 190, h: 60 }, { w: 122, h: 52 }];
    let ty = cy;
    tiers.forEach(({ w, h }) => {
        ctx.beginPath();
        ctx.roundRect(cx - w / 2, ty - h, w, h, 10);
        ctx.fill();
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(cx - w / 2, ty - h + 13);
        ctx.lineTo(cx + w / 2, ty - h + 13);
        ctx.strokeStyle = "rgba(243,208,133,0.5)";
        ctx.lineWidth = 1.5;
        ctx.stroke();
        ctx.strokeStyle = "#F3D085";
        ctx.lineWidth = 3;
        ty -= h + 6;
    });
    for (let i = -1; i <= 1; i++) {
        const candleX = cx + i * 40;
        ctx.fillStyle = "#F3D085";
        ctx.fillRect(candleX - 4, ty - 36, 8, 36);
        const flameGrad = ctx.createRadialGradient(candleX, ty - 46, 2, candleX, ty - 44, 13);
        flameGrad.addColorStop(0, "#fff6d8");
        flameGrad.addColorStop(0.5, "#ffd35e");
        flameGrad.addColorStop(1, "rgba(255,157,46,0)");
        ctx.fillStyle = flameGrad;
        ctx.beginPath();
        ctx.ellipse(candleX, ty - 44, 7, 12, 0, 0, Math.PI * 2);
        ctx.fill();
    }
    ctx.strokeStyle = "rgba(243,208,133,0.7)";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.ellipse(cx, cy + 12, 180, 20, 0, 0, Math.PI * 2);
    ctx.stroke();

    ctx.fillStyle = "rgba(251,247,238,0.92)";
    ctx.font = "400 33px 'Outfit', sans-serif";
    ctx.fillText("Certified fabulous. Universally appreciated.", W / 2, 1148);
    ctx.fillText("Officially exempt from all responsibilities today.", W / 2, 1194);

    ctx.fillStyle = "rgba(196,181,253,0.85)";
    ctx.font = "italic 400 30px 'Cormorant Garamond', Georgia, serif";
    ctx.fillText("Happy Birthday, Mary", W / 2, 1246);

    ctx.fillStyle = "rgba(243,208,133,0.65)";
    ctx.font = "500 19px 'JetBrains Mono', monospace";
    ctx.fillText("MADE WITH APPRECIATION — JERRY | WEBTECHGUIDER", W / 2, 1282);

    return canvas;
}

export function loadPhoto() {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = () => resolve(null);
        img.src = "/images/mary.webp";
    });
}

export async function posterDataUrl() {
    const photo = await loadPhoto();
    const canvas = document.createElement("canvas");
    renderPoster(canvas, photo);
    return canvas.toDataURL("image/png");
}

export function downloadPoster() {
    return loadPhoto().then(
        (photo) =>
            new Promise((resolve) => {
                const canvas = document.createElement("canvas");
                renderPoster(canvas, photo);
                canvas.toBlob((blob) => {
                    if (!blob) { resolve(false); return; }
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "mary-manzur-birthday-poster-2026.png";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    setTimeout(() => URL.revokeObjectURL(url), 4000);
                    resolve(true);
                }, "image/png");
            })
    );
}
